import React, { useContext } from 'react';
import { Select, Typography, Flex } from '@app/ui';
import { useFormikContext } from 'formik';
import { FiltersFormContext } from './FiltersFormContext';
import { INSIGHT_TYPES_OPTIONS as options } from '@app/components/automated-insights/constants';

const InsightTypeFilter = () => {
    const { setFormValue, setIsSettingFilters } =
        useContext(FiltersFormContext);
    const { values } = useFormikContext<{ insightsIds: string[] }>();

    return (
        <Flex
            data-test="new-insight-dropdown"
            style={{ flexDirection: 'column' }}
            flex={1}
        >
            <Typography.Text>Insight Type</Typography.Text>
            <Select
                mode="multiple"
                placeholder="Select Insight Type"
                options={options}
                value={values.insightsIds}
                onChange={setFormValue('insightsIds')}
                onDropdownVisibleChange={open =>
                    setIsSettingFilters('insightsIds', open)
                }
                allowClear
            />
        </Flex>
    );
};

export default InsightTypeFilter;
